<div class="AmPassengerListPriorityCode">
  <div class="AmPassengerListPriorityCode-titles fs-18px lh-26px fw-medium-x">
    <div class="AmPassengerListPriorityCode-contentOne">
      <span *ngIf="type == 'upgrade'">{{ 'ModalPassengersPriorityCode.seatAssigned' | translate: { cant: listSeatAssing.length } }}</span>
      <span *ngIf="type == 'standby'">{{ 'ModalPassengersPriorityCode.seatAssigned' | translate: { cant: listSeatAssing.length } }}</span>
    </div>
    <div class="AmPassengerListPriorityCode-contentTwo">
      <span *ngIf="type == 'upgrade' && showTitleTwo">{{ 'ModalPassengersPriorityCode.upgradeRemaining' | translate: { cant: listSeatNotAssing.length } }}</span>
      <span *ngIf="type == 'standby' && showTitleTwo">{{ 'ModalPassengersPriorityCode.seatsAvailable' | translate: { cant: listSeatNotAssing.length } }}</span>
    </div>
  </div>
  <app-am-scroll [height]="380">
    <div class="AmPassengerListPriorityCode-lists">
      <div class="AmPassengerListPriorityCode-contentOne"
        [ngClass]="{ 'AmPassengerListPriorityCode-contentOne--expanded': listSeatAssing.length <= 4 && upgradeList.length <= 4 }">
        <div class="AmPassengerListPriorityCode-listOne">
          <am-passenger-list-priority-code-item
            *ngFor="let item of listSeatAssing let i = index;"
            [passenger]="item"
            [numberList]="(i + 1)"
            [typeList]="type"
          ></am-passenger-list-priority-code-item>
        </div>
      </div>
      <div class="AmPassengerListPriorityCode-contentTwo"
        [ngClass]="{ 'AmPassengerListPriorityCode-contentTwo--expanded': listSeatNotAssing.length <= 4 && upgradeList.length <= 4 }">
        <div class="AmPassengerListPriorityCode-listTwo">
          <am-passenger-list-priority-code-item
            *ngFor="let item of listSeatNotAssing; let i = index;"
            [passenger]="item"
            [numberList]="(i + 1)"
            [typeList]="type"
          ></am-passenger-list-priority-code-item>
        </div>
      </div>
    </div>
  </app-am-scroll>
</div>
